import React from 'react';
import Heading from '../../../../../generic-components/Heading';
import { IInvoiceRecipient } from '../../types/types';
import Button from '../../../../../generic-components/Button';
import { STYLES } from '../../consts/consts';
import { Avatar, AvatarSize } from '../../../../../DesignSystem/VendorProfile/Avatar';

const { INVOICE_CREATION: { CLIENT_PROFILE: componentStyles } } = STYLES;

interface IProps {
  clientData: IInvoiceRecipient;
  singleMode?: boolean;
  id?: string;
  onClick?: () => void;
}

export const ClientProfile = ({
  clientData, singleMode, id, onClick,
}: IProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Button
      childElement={(
        <div className={`${componentStyles.WRAPPER} ${!singleMode ? componentStyles.ADDON_WRAPPER_SINGLE_MODE : componentStyles.ADDON_WRAPPER_LIST_MODE}`}>
          <div className={componentStyles.NAME_TAG_WRAPPER}>
            <Avatar name={clientData.name} id={clientData.externalId} size={AvatarSize.LARGE} />
          </div>
          <div className={componentStyles.CLIENT_DATA_WRAPPER}>
            <Heading title={clientData?.name} className={componentStyles.CLIENT_NAME} />
            <Heading title={clientData?.email} className={componentStyles.CLIENT_EMAIL} />
          </div>
        </div>
      )}
      className={componentStyles.BUTTON}
      onClick={handleClick}
      id={id || `selectorButton_${clientData.name}`}
    />
  );
};
